import React from 'react';
import Data from './Data';

const Sidebar = (props) => <Data {...props} />;

export default React.memo(Sidebar);
